import type { CleaningOptions, OutputMode } from '../types/app';

export const siteConfig = {
  brandName: 'Kopivaro',
  domain: 'https://kopivaro.de',
  publisher: 'GermanHost',
  publisherWebsiteName: 'GermanHost.eu',
  publisherWebsite: 'https://germanhost.eu/',
  contactEmail: 'info@germanhost.eu',
  operator: {
    name: 'GermanHost',
    representative: 'Paul Kubinka',
    addressLines: ['Wiesengasse 2A', '55127 Mainz', 'Deutschland'],
    phone: '015679 647766',
    contentResponsible: 'Paul Kubinka',
  },
  ads: {
    enabled: true,
    provider: 'Google AdSense',
    publisherId: 'ca-pub-7136614867281447',
    autoAds: true,
    consentProvider: 'Google Privacy & messaging',
    slots: {
      introduction: '',
      result: '',
      guide: '',
    },
  },
  publicCounters: {
    enabled: true,
    endpoint: '/api/counter.php',
  },
  defaultOutputMode: 'word' as OutputMode,
  availableDownloads: ['txt', 'html', 'md', 'pdf', 'docx'] as const,
} as const;

export const defaultCleaningOptions: CleaningOptions = {
  duplicateSpaces: true,
  excessBlankLines: true,
  normalizeNbsp: true,
  removeZeroWidth: true,
  removeSoftHyphens: true,
  normalizeSpecialSpaces: true,
  convertMarkdown: true,
  removeUnnecessaryHtml: true,
  repairPdfBreaks: true,
  joinHyphenation: true,
  detectLists: true,
  preserveParagraphs: true,
  fixPunctuationSpacing: true,
};
